// removed by extract-text-webpack-plugin
module.exports = {"dataPoint":"DetailsQuotes__dataPoint__f7b6cce7","value":"DetailsQuotes__value__f7b6cce7","quote":"DetailsQuotes__quote__f7b6cce7","wrapper":"DetailsQuotes__wrapper__f7b6cce7","boundaryHeader":"DetailsQuotes__boundaryHeader__f7b6cce7","column":"DetailsQuotes__column__f7b6cce7","method":"DetailsQuotes__method__f7b6cce7","price":"DetailsQuotes__price__f7b6cce7","applyFreeShipping":"DetailsQuotes__applyFreeShipping__f7b6cce7"};


//////////////////
// WEBPACK FOOTER
// ./assets/js/newPdp/components/Shipping/ShippingDetailsModal/DetailsQuotes.scss
// module id = 1842
// module chunks = 7 16